<template lang="pug">
div
  nav.navbar
    .navbar-brand
      a(href="/")
        img.logo(src="@/assets/logo.png" alt="")
    ul.nav.justify-content-end
      li.nav-item
          a.nav-link(href='/features' alt="features") FEATURES        
      li.nav-item
          a.nav-link(href='/partners' alt="partners") PARTNERS
      li.nav-item
          a.nav-link.active(href='/pricing' alt="pricing") PRICING
      li.nav-item
          a.nav-link(href='/contact' alt="contact us") CONTACT US
      li.nav-item
          a.nav-link(href='/login' alt="login") LOGIN
  .container
    .row
      .col-lg-6.offset-lg-3.col-12.card.shadow
        .row
          .card-header.py-3(style="width:100%;")
            h3.m-0.font-weight-bold.text-primary Recover Password
        .card-body      
          .col-lg-12.login-form
            .col-lg-12.login-form
              div
                .form-group
                  label.form-control-label Email
                  input.form-control(type='email' v-model="email")
                .col-lg-12.loginbttm              
                  .col-lg-12.login-btm.login-button.text-right
                    button.btn.btn-primary(v-on:click="recoverPassword") Recover Password
                  .col-lg-3.col-md-2
</template>

<script>
export default {
  name: 'RecoverPassword',
  props: {

  },
  data:function(){
    return{
      email:null,
      msg:null,
    }
  },
  metaInfo: {
    title: 'Recover Password',
  },
  methods:{
    async recoverPassword(){
      try {
        let data = new FormData();
        data.append('email', this.email);
        const response = await this.axios.post('/rp/server/recover_password', data);
        this.flash('An email has been sent', 'success');
      }catch(error) {
        this.flash(error,'error')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
 .login-box{
  padding:30px;
  border-radius: 7px;
}
@font-face {
  font-family: Alata-Regular;
  src: url('../assets/fonts/Alata-Regular.ttf');
}
@font-face{
font-family: "Circular Book";
  src: url('../assets/fonts/CircularStd-Book.otf');
}
*{
  color: #585655;
  
}
.navbar-brand {
    display: inline-block;
    padding-top: .3125rem;
    padding-bottom: .3125rem;
    margin-right: 1rem;
    font-size: 1.25rem;
    line-height: inherit;
    white-space: nowrap;
}
.logo{
  width:150px;
}
.navbar{
  font-family: "Circular Book";
  a{
    color: #585655;
  }
  a:hover{
    color: #585655;
  }
}
button{
  color:white;
}
</style>
